module.exports = __webpack_public_path__ + "images/boatyard_logo_rossmarine.48fc045408fddf5943c623d3cbabfa70.png";